export const makePixel = (input: string | number) => {
  if (typeof input === 'string' && (input.indexOf('px') > -1 || input.indexOf('%') > -1)) {
    return input
  } else {
    return `${input}px`
  }
}